// extracted by css-extract-rspack-plugin
export default {"subtitle":"TsmaDs","toggle":"xjOAIq"};